export const TID = {
    // Header
    header: "site-header",
    langToggleEN: "lang-toggle-en",
    langToggleNL: "lang-toggle-nl",
    navHome: "nav-home",
    navPhilosophy: "nav-philosophy",
    navFramework: "nav-framework",
    navCapabilities: "nav-capabilities",
    navConstitution: "nav-constitution",
    navLibrary: "nav-library",
    navSteward: "nav-steward",
    navLegacy: "nav-legacy",
    navContact: "nav-contact",
    // Hero
    heroTitle: "hero-title",
    heroSubtitle: "hero-subtitle",
    heroExplore: "hero-explore",
    // Home sections
    sectionOpening: "section-opening",
    sectionWhy: "section-why",
    sectionLighthouse: "section-lighthouse",
    sectionPrinciples: "section-principles",
    sectionFramework: "section-framework",
    sectionCapabilities: "section-capabilities",
    sectionConstitution: "section-constitution",
    sectionSteward: "section-steward",
    sectionLibrary: "section-library",
    sectionLegacy: "section-legacy",
    sectionLetters: "section-letters",
    sectionContact: "section-contact",
    // Contact
    contactName: "contact-name",
    contactEmail: "contact-email",
    contactOrg: "contact-org",
    contactMessage: "contact-message",
    contactSubmit: "contact-submit",
    // Letters
    lettersName: "letters-name",
    lettersEmail: "letters-email",
    lettersSubmit: "letters-submit",
    // Library / Collections
    libraryList: "library-list",
    essayCard: "essay-card",
    essayReader: "essay-reader",
    essayBack: "essay-back",
    collectionFilter: "collection-filter",
    pageCollection: "page-collection",
    // Dedicated pages
    pageFramework: "page-framework",
    pageConstitution: "page-constitution",
    pageLibrary: "page-library",
    pageLegacy: "page-legacy",

    // ── V2 additions (Phase A — seeded, wired in later phases) ──
    // Accessibility
    skipLink: "skip-link",

    // Nav (V2)
    navInstitute: "nav-institute",
    navResearch: "nav-research",

    // Hero (V2)
    heroPrimaryCta: "hero-primary-cta",
    heroSecondaryCta: "hero-secondary-cta",

    // Four pillars section
    sectionPillars: "section-pillars",
    pillarResearch: "pillar-research",
    pillarLibrary: "pillar-library",
    pillarProjects: "pillar-projects",
    pillarImpact: "pillar-impact",

    // Capabilities preview (retained on Home)
    capabilitiesPreview: "capabilities-preview",
    capabilitiesExploreAll: "capabilities-explore-all",

    // New pages
    pageInstitute: "page-institute",
    pageImpact: "page-impact",
};
